/**
 * Shared horizontal layout for the worksheet's period tables and the charts
 * drawn beneath them (MOR-1282).
 *
 * Every period table is a fixed-width metric column followed by equal-width
 * period columns; each chart reserves the same metric width as its Y-axis
 * gutter and spans the rest, so a period's column and its chart position
 * share one centre. Table and chart sit in one horizontal scroll region with
 * the same minimum width, so at narrow widths they scroll together instead of
 * compressing out of step.
 */

/** Width of the metric-label column, and of each chart's Y-axis gutter. */
export const METRIC_COLUMN_PX = 200;

/** Narrowest a period column may get before the region scrolls instead. */
export const MIN_PERIOD_COLUMN_PX = 120;

/** Minimum width shared by a period table and its chart. */
export function periodRegionMinWidth(periodCount: number): number {
  return METRIC_COLUMN_PX + periodCount * MIN_PERIOD_COLUMN_PX;
}
